import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { BoxListTruckService } from '../box-list-truck/box-list-truck.service';
import { ApiConService } from '../shared/api-con.service';
import { SituacaoOdometro, Util } from '../shared/Util';
import { GraphicService } from '../shared/graphic.service';
import { BoxHistoricoAcoesService } from '../box-historico-acoes/box-historico-acoes.service';
import { FormBuilder, FormGroup, FormsModule } from '@angular/forms';
import { DashboardService } from '../dashboard/dashboard.service';
import swal from 'sweetalert2';
import { DatePipe, NgClass, NgIf, NgFor, NgStyle } from '@angular/common';
import { JsonReturn, ObjectParam } from '../shared/interface/generic-interface';
import { LoadedModules } from '../shared/esri-load-control.service';
import { NotificationService } from '../shared/notification.service';
import { BoxDistEntregaComponent } from './box-dist-entrega/box-dist-entrega.component';
import { TextoLinkComponent } from '../shared/componentes/texto-link/texto-link.component';
import { StatusRoteiroComponent } from '../status-roteiro/status-roteiro.component';
import { BotaoPrimarioComponent } from '../shared/componentes/botao-primario/botao-primario.component';
import { DualInfoComponentComponent } from '../shared/componentes/dual-info-component/dual-info-component.component';

declare let jsPDF;
@Component({
    selector: 'box-info-delivery-router',
    templateUrl: './box-info-delivery-router.component.html',
    styleUrls: ['./box-info-delivery-router.component.css'],
    providers: [DatePipe],
    standalone: true,
    imports: [NgClass, NgIf, NgFor, BoxDistEntregaComponent, TextoLinkComponent, NgStyle, StatusRoteiroComponent, BotaoPrimarioComponent, DualInfoComponentComponent, FormsModule, DatePipe]
})
export class BoxInfoDeliveryRouterComponent implements OnInit {

  @Input() dados;
  distanciaPercorrida: boolean = true;
  distanciaPlanejada: boolean = true;
  formularioConfigApp: FormGroup;
  versaoApp: string;
  contemManterSequenciaEntrega: boolean;
  kmPercorridaAtualizada = false;
  radioValue: string;
  kmOdometroInicio: number = null;
  kmOdometroFinal: number = null;
  dadosOdometro: any;
  datakmOdometroInicio: string = null;
  dataKmOdometroFinal: string = null;
  loadingBtnDownloadOdometro = false;
  solicitaOdometro = false;
  descricaoUltimaEntrega = 'Última entrega';
  imgUltimaEntrega = 'assets/img/status_odometro_final.svg'
  distanciaPercorridaPorcentagem = 0
  icones: any[] = [];
  listaKmPercorrida = [];
  tituloDistancia = ''
  fotoOdoInicial: string | null = null;
  loadingFotoOdo: boolean = false;
  showModalOdometro: boolean = false;
  fotoOdoFinal: string | null = null;
  dataFinalOdometro: string | null = null;
  dataInicialOdometro: string | null = null;
  distanciaOdometro: number = null;
  private imagesLoaded: number = 0;
  distanciasPercorridaMotorAjud = [];
  kmOdometroInicioEdit: number = 0;
  kmOdometroFinalEdit: number = 0;
  modoEdicaoOdometro: boolean = false;
  @Input() roteiroCrossdocking: boolean = false;


  @ViewChild('progressBar') progressBar!: ElementRef;

  constructor
    (
      private boxListTruckService: BoxListTruckService,
      private util: Util,
      public graphicService: GraphicService,
      private apiConService: ApiConService,
      private boxHistoricoAcoesService: BoxHistoricoAcoesService,
      private fb: FormBuilder,
      private dashboardService: DashboardService,
      private datePipe: DatePipe,
      private notificationService: NotificationService
    ) { }

  async ngOnInit() {
    const infoRota = JSON.parse(this.boxListTruckService.listTruckService.InfoRota)
    this.solicitaOdometro = infoRota?.InfoRoteirizacao?.solicitaFotoOdometro ?? false;
    let configuracaoApp = infoRota.ConfigRecebimentoApp || "0";
    this.contemManterSequenciaEntrega = infoRota.ManterSequenciaEntrega ?? null;

    let manterSequenciaEntrega = infoRota.ManterSequenciaEntrega == true ? 1 : 0;
    let permitirInicioPrevisao = infoRota?.PermitirIniciarRoteiroAntesPrevisao
    let permitirIniciarRoteiroAntesPrevisao = permitirInicioPrevisao != null ? permitirInicioPrevisao ? 1 : 0 : 1
    this.versaoApp = this.boxListTruckService.listTruckService.VersaoApp;

    this.formularioConfigApp = this.fb.group({
      config: [configuracaoApp],
      manterSequenciaEntrega: [manterSequenciaEntrega],
      permitirIniciarRoteiroAntesPrevisao: [permitirIniciarRoteiroAntesPrevisao],
    })

    await this.atualizaDadosOdometro();
    this.atualizaDadosUltimaEntregas(infoRota);

    await this.getInfoDeliveryRouter();
    this.carregaDistanciaPercorrida(infoRota)
    this.alterarKmPercorridaInfoRota();
    this.distanciaPercorridaPorcentagem = (+this.graphicService.distanciaTotalRealizada.toFixed(1) * 100 / +this.graphicService.distanciaTotalPlanejada.toFixed(1));
  }


  alternarModalOdometro() {
    this.carregarFotoOdometro();
    this.showModalOdometro = !this.showModalOdometro;
  }

  async carregarFotoOdometro() {
    this.loadingFotoOdo = true;
    try {
      let fotoInicio, fotoFinal;
      if (this.kmOdometroInicio != null) {
        fotoInicio = await this.boxListTruckService.getFotoOdometro(
          this.boxListTruckService.roteiroSelecionado,
          SituacaoOdometro.Inicio
        );
        this.fotoOdoInicial = `data:image/jpeg;base64,${fotoInicio}`;
      }

      if (this.kmOdometroFinal != null) {
        fotoFinal = await this.boxListTruckService.getFotoOdometro(
          this.boxListTruckService.roteiroSelecionado,
          SituacaoOdometro.Final
        );
        this.fotoOdoFinal = `data:image/jpeg;base64,${fotoFinal}`;
      }

      this.dataInicialOdometro = this.datePipe.transform(this.datakmOdometroInicio, 'dd/MM/yyyy HH:mm');
      this.dataFinalOdometro = this.datePipe.transform(this.dataKmOdometroFinal, 'dd/MM/yyyy HH:mm');
      this.distanciaOdometro = (this.kmOdometroFinal - this.kmOdometroInicio)


    } catch (error) {
      console.error('Erro ao carregar as fotos do odômetro:', error);
    } finally {
      this.loadingFotoOdo = false;
    }
  }


  atualizaIconeKmPercorrida() {
    this.listaKmPercorrida = [];
    if (!this.solicitaOdometro) {
      const valor = +this.graphicService.distanciaTotalRealizada.toFixed(1) * 100 / +this.graphicService.distanciaTotalPlanejada
      this.gerarListaIcons(valor);
      this.distanciaPercorridaPorcentagem = valor;
    }
  }

  gerarListaIcons(valor) {

    const larguraBarraProgresso = this.progressBar.nativeElement.offsetWidth;
    const larguraIcone = 18;
    const numeroIcone = Math.floor(larguraBarraProgresso / larguraIcone);

    this.icones = Array(numeroIcone).fill(1);

    for (let i = 0; i < this.icones.length; i++) {
      const valorCalculado = (i + 1) * 5;
      if (valorCalculado <= valor && this.listaKmPercorrida.length < 20) {
        this.listaKmPercorrida.push(valorCalculado);
      }
    }
  }

  async getInfoDeliveryRouter() {
    this.dados.primeira_entrega = this.dados.primeira_entrega != undefined && this.dados.primeira_entrega != null ? this.util.converteData(this.dados.primeira_entrega) : ''
    this.dados.ultima_entrega = this.dados.ultima_entrega != undefined && this.dados.ultima_entrega != null ? this.util.converteData(this.dados.ultima_entrega) : '';
  }
  exibirDistanciaPercorrida() {
    this.distanciaPercorrida = !this.distanciaPercorrida;
    this.graphicService.exibirDistanciaPercorrida(this.distanciaPercorrida);
  }

  exibirDistanciaPlanejada() {
    this.distanciaPlanejada = !this.distanciaPlanejada;
    this.graphicService.exibirDistanciaPlanejada(this.distanciaPlanejada);
  }

  alterarKmPercorridaInfoRota() {
    const kmOdometroInicio = this.boxListTruckService.listTruckService.KmOdometroInicio ?? null;
    const kmOdometroFinal = this.boxListTruckService.listTruckService.KmOdometroFinal ?? null;
    let kmPercorrida = JSON.parse(this.boxListTruckService.listTruckService.InfoRota).KmPercorrido;

    if (this.boxListTruckService.listTruckService.IdRoteiroSituacao === 5 && kmPercorrida === undefined && kmOdometroInicio == null && kmOdometroFinal == null) {
      let infoRota = JSON.parse(this.boxListTruckService.listTruckService.InfoRota);
      let numeroRoteiro = this.boxListTruckService.roteiroSelecionado

      ///Adiciona os campos NomeMotorista,PlacaVeiculo,DescricaoVeiculo devido no get os nomes dos campos  retornar com AS nome_motorista,cod_veiculo, veiculo...
      this.boxListTruckService.listTruckService = {
        ...this.boxListTruckService.listTruckService,
        NomeMotorista: this.boxListTruckService.listTruckService.nome_motorista,
        PlacaVeiculo: this.boxListTruckService.listTruckService.cod_veiculo,
        DescricaoVeiculo: this.boxListTruckService.listTruckService.veiculo
      }


      setTimeout(async () => {
        infoRota = {
          ...infoRota,
          KmPercorrido: this.graphicService.distanciaTotalRealizada.toFixed(3),
        }

        let infoRotaString = JSON.stringify(infoRota);
        this.boxListTruckService.listTruckService.InfoRota = infoRotaString;
        let objParam: ObjectParam = {
          roteiro: this.boxListTruckService.listTruckService
        }
        objParam.roteiro.NumeroRoteiro = this.boxListTruckService.listTruckService.roteiro
        await this.apiConService.put('DCroteiros', numeroRoteiro.toString(), objParam)

      }, 5000)
    }
  }

  async atualizaKmPercorrida() {
    this.kmPercorridaAtualizada = true;
    let distanciaTotal = 0
    let pontosComUltimaPosicao = this.boxHistoricoAcoesService.listHistoryAction.filter(
      x => (x.CodigoAcao === 1 || x.CodigoAcao === 7) && x.Latitude != 0
    );

    let pontos = pontosComUltimaPosicao.map((item, index) => {
      if (item.CodigoAcao == 1) {
        return { ponto: item, index: index };
      }
    }).filter((item) => { if (item != undefined) return item }).reduce((acc, curr) => {
      const x = acc.find(value => value.ponto.CodigoAcao === curr.ponto.CodigoAcao && value.ponto.Data === curr.ponto.Data && value.ponto.Latitude === curr.ponto.Latitude && value.ponto.Longitude === curr.ponto.Longitude);
      if (!x) {
        return acc.concat([curr]);
      } else {
        return acc;
      }
    }, []);

    let versaoApp = this.boxListTruckService.listTruckService.VersaoApp;

    if (versaoApp >= '2.0.0' && this.util.cnpjEmpresas.length > 0) {
      let filtroCnpjs = pontos.filter((ponto) => {
        let cnpj = JSON.parse(ponto.ponto.Informacoes).cnpj
        return this.util.cnpjEmpresas.includes(cnpj)
      });
      pontos = filtroCnpjs;
    }

    for (let i = 0; i < pontos.length; i++) {
      if (i > 1) {
        let distancia = this.util.calcularDistanciaGeo(pontos[i - 1].ponto.Latitude, pontos[i - 1].ponto.Longitude, pontos[i].ponto.Latitude, pontos[i].ponto.Longitude);
        distanciaTotal += distancia;
      }
    }

    this.graphicService.distanciaTotalRealizada = distanciaTotal;

    if (this.boxListTruckService.listTruckService.IdRoteiroSituacao === 5) {
      let infoRota = JSON.parse(this.boxListTruckService.listTruckService.InfoRota);

      this.boxListTruckService.listTruckService = {
        ...this.boxListTruckService.listTruckService,
        NomeMotorista: this.boxListTruckService.listTruckService.nome_motorista,
        PlacaVeiculo: this.boxListTruckService.listTruckService.cod_veiculo,
        DescricaoVeiculo: this.boxListTruckService.listTruckService.veiculo
      }

      delete infoRota.KmPercorrido;
      infoRota = {
        ...infoRota,
        KmPercorrido: this.graphicService.distanciaTotalRealizada.toFixed(3),
      }

      let infoRotaString = JSON.stringify(infoRota);
      this.boxListTruckService.listTruckService.InfoRota = infoRotaString;
      let objParam: ObjectParam = {
        roteiro: this.boxListTruckService.listTruckService
      }
      objParam.roteiro.NumeroRoteiro = this.boxListTruckService.listTruckService.roteiro
      await this.apiConService.put('DCroteiros', this.boxListTruckService.roteiroSelecionado.toString(), objParam);

    }

  }

  async atualizaConfigApp() {
    let config = this.formularioConfigApp.value.config;
    let infoRota = JSON.parse(this.boxListTruckService.listTruckService.InfoRota);

    let contemNomeMotorista = this.boxListTruckService.listTruckService.nome_motorista;

    if (contemNomeMotorista) {
      this.boxListTruckService.listTruckService = {
        ...this.boxListTruckService.listTruckService,
        NomeMotorista: this.boxListTruckService.listTruckService.nome_motorista,
        PlacaVeiculo: this.boxListTruckService.listTruckService.cod_veiculo,
        DescricaoVeiculo: this.boxListTruckService.listTruckService.veiculo
      }
    }

    delete infoRota.ConfigRecebimentoApp;
    infoRota = {
      ...infoRota,
      ConfigRecebimentoApp: config.toString()
    }

    let infoRotaString = JSON.stringify(infoRota);
    this.boxListTruckService.listTruckService.InfoRota = infoRotaString;
    let objParam: ObjectParam = {
      roteiro: this.boxListTruckService.listTruckService
    }
    objParam.roteiro.NumeroRoteiro = this.boxListTruckService.listTruckService.roteiro
    await this.apiConService.put('DCroteiros', this.boxListTruckService.roteiroSelecionado.toString(), objParam);

  }

  atualizaCoordenadas() {
    this.dashboardService.nuRotAtualizaCoordenadas = this.boxListTruckService.roteiroSelecionado;
    document.getElementById('voltaTelaInicial').click();
    document.getElementById('abrirVisualizadorDeRoteiros').click();
    this.dashboardService.nuRotAtualizaCoordenadas = 0;
  }

  async desativaCoordenada() {
    const idCooordenada = window["idCoordenada"]
    const resultado = await this.confirmacaoDesativaCoordenada()

    if (resultado) {
      try {
        await this.apiConService.patch(`DCcoordenadas/desativaCoordenada/${idCooordenada}`);
        this.atualizaCoordenadas();
      } catch (error) {
        console.log("Erro ao atualizar coordenada")
      }
    }
  }


  confirmacaoDesativaCoordenada(): Promise<boolean> {

    return swal.fire({
      text: "Tem certeza que deseja desativar essa coordenada?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Desativar',
      cancelButtonText: "Voltar"
    }).then((result) => result.isConfirmed)
  }

  atualizaManterSequencia() {
    let manterSequenciaEntrega = this.formularioConfigApp.value.manterSequenciaEntrega == 1 ? true : false;
    let infoRota = JSON.parse(this.boxListTruckService.listTruckService.InfoRota);

    delete infoRota.ManterSequenciaEntrega
    infoRota = {
      ...infoRota,
      ManterSequenciaEntrega: manterSequenciaEntrega
    }
    let objParam: ObjectParam = {
      infoRota: JSON.stringify(infoRota)
    }
    this.apiConService.put('DCroteiros/infoRota', this.boxListTruckService.roteiroSelecionado.toString(), objParam)

  }

  atualizaPermiInicRotAntesPrevisao() {
    let permitirIniciarRoteiroAntesPrevisao = this.formularioConfigApp.value.permitirIniciarRoteiroAntesPrevisao == 1 ? true : false;
    let infoRota = JSON.parse(this.boxListTruckService.listTruckService.InfoRota);

    delete infoRota.PermitirIniciarRoteiroAntesPrevisao
    infoRota = {
      ...infoRota,
      PermitirIniciarRoteiroAntesPrevisao: permitirIniciarRoteiroAntesPrevisao
    }
    let objParam: ObjectParam = {
      infoRota: JSON.stringify(infoRota)
    }
    this.apiConService.put('DCroteiros/infoRota', this.boxListTruckService.roteiroSelecionado.toString(), objParam)

  }

  async atualizaDadosOdometro() {
    this.fotoOdoInicial = null;
    this.fotoOdoFinal = null
    this.kmOdometroInicio = this.dados.KmOdometroInicio;
    this.kmOdometroFinal = this.dados.KmOdometroFinal;
    this.tituloDistancia = this.kmOdometroInicio == null || this.kmOdometroFinal == null ? 'Distância percorrida' : 'Percorrida no odômetro'

    if (this.kmOdometroInicio != null) {
      let retorno: JsonReturn = await this.apiConService.patch(`DCcoordenadas/dadosOdometro/${this.boxListTruckService.roteiroSelecionado}`)
      this.dadosOdometro = retorno.response;
      this.datakmOdometroInicio = this.dadosOdometro[0].Data.replace('Z', '');

      if (this.kmOdometroFinal != null) {
        this.dataKmOdometroFinal = this.dadosOdometro[1].Data.replace('Z', '');
      }

    }
  }

  async downloadFotosOdometros() {
    this.loadingBtnDownloadOdometro = true;
    const dataInicialFormatada = this.datePipe.transform(this.datakmOdometroInicio, 'dd/MM/yyyy HH:mm');
    const dataFinalFormatada = this.datePipe.transform(this.dataKmOdometroFinal, 'dd/MM/yyyy HH:mm');
    const doc = new jsPDF();

    const img1Path = this.fotoOdoInicial;
    const img2Path = this.fotoOdoFinal;

    const img1 = new Image();
    const img2 = new Image();

    img1.src = img1Path;
    if (this.kmOdometroFinal != null) {
      img2.src = img2Path;
    }

    img1.onload = () => {

      if (this.kmOdometroFinal != null) {
        img2.onload = () => {
          doc.text(`Início`, 10, 10);
          doc.text(`${this.kmOdometroInicio} Km | ${dataInicialFormatada}`, 10, 17);
          doc.text(`Distância: ${this.kmOdometroFinal - this.kmOdometroInicio} km`, 10, 25);
          doc.addImage(img1, 'PNG', 10, 30, 90, 90);

          doc.text(`Final`, 110, 10);
          doc.text(`${this.kmOdometroFinal} Km | ${dataFinalFormatada}`, 110, 17);
          doc.addImage(img2, 'PNG', 110, 30, 90, 90);
          doc.save(`odometro_roteiro_${this.boxListTruckService.roteiroSelecionado}.pdf`);
        };
      } else {
        doc.text(`Início`, 10, 10);
        doc.text(`${this.kmOdometroInicio} Km | ${dataInicialFormatada}`, 10, 17);
        if (this.kmOdometroFinal != null) {
          doc.text(`Distância: ${this.kmOdometroFinal - this.kmOdometroInicio} km`, 10, 25);
        }
        doc.addImage(img1, 'PNG', 10, 30, 90, 90);
        doc.text(`Final`, 110, 10);
        doc.text(`--- Km | --/--/---- --:--`, 110, 17);

        doc.setFillColor(246, 246, 248);
        doc.roundedRect(105, 30, 90, 90, 8, 8, 'F');
        doc.setFontSize(12);
        doc.text('Odômetro final não enviado até o momento', 110, 75);

        doc.save(`odometro_roteiro_parcial${this.boxListTruckService.roteiroSelecionado}.pdf`);
      }

    };

    this.loadingBtnDownloadOdometro = false;


  }

  atualizaDadosUltimaEntregas(infoRota) {
    if (infoRota?.RetornoOrigem ?? false) {
      this.imgUltimaEntrega = 'assets/img/ultima_entrega_dist.svg'
      this.descricaoUltimaEntrega = 'Distribuidora'
    } else if (infoRota?.RetornoMotorista ?? false) {
      this.imgUltimaEntrega = 'assets/img/ultima_entrega_motor.svg'
      this.descricaoUltimaEntrega = 'Casa motorista'
    }
  }

  async carregaDistanciaPercorrida(infoRota) {
    const cores = ['#0009E1', '#E76203', '#237506'];

    let distanciaTotal = 0;
    let pesoTotal = 0;
    let volTotal = 0;
    if (infoRota.RegistrarDistanciaEntrega == true) {
      const responsePedido: JsonReturn = await this.apiConService.patch('DCroteiroPedido/' + this.boxListTruckService.roteiroSelecionado + '/0');
      const retorno: JsonReturn = await this.apiConService.patch(`DCcoordenadaEntrega/` + this.boxListTruckService.listTruckService.roteiro);

      if (retorno.sucesso && retorno.response.length) {

        const entregasMotoristas = retorno.response.filter((entrega) => entrega.CdMotor)
        const entregasAjudantes = retorno.response.filter((entrega) => entrega.CdAjudante)

        const agrupadoMotorista = entregasMotoristas.reduce((clientes, item) => {
          if (!clientes[item.CdMotor]) {
            clientes[item.CdMotor] = [];
          }
          clientes[item.CdMotor].push(item);
          return clientes;
        }, {});

        const agrupadoAjudante = entregasAjudantes.reduce((clientes, item) => {
          if (!clientes[item.CdAjudante]) {
            clientes[item.CdAjudante] = [];
          }
          clientes[item.CdAjudante].push(item);
          return clientes;
        }, {});

        const listaMotoristas = Object.keys(agrupadoMotorista).map(CdMotor => ({
          nome: this.dados.nome_motorista,
          ajudante: false,
          entregas: agrupadoMotorista[CdMotor]
        }));

        const listaAjudantes = Object.keys(agrupadoAjudante).map(CdAjudante => ({
          nome: infoRota.Ajudante.find((ajud) => ajud.cdAjudante.trim() == CdAjudante.trim()).nome,
          ajudante: true,
          entregas: agrupadoAjudante[CdAjudante]
        }));

        this.distanciasPercorridaMotorAjud = [...listaMotoristas, ...listaAjudantes];

        for (let i = 0; i < this.distanciasPercorridaMotorAjud.length; i++) {

          const grupo = ((i + 1) - 1) % 3;
          const corRota = cores[grupo];

          distanciaTotal = 0;
          pesoTotal = 0;
          volTotal = 0;
          const codigosClientes = [
            ...new Set(
              this.distanciasPercorridaMotorAjud[i].entregas.map((entrega) => entrega.CodigoCliente)
            ),
          ];

          const pedidos = responsePedido.response.filter((pedido) => codigosClientes.includes(pedido.CodigoCliente));

          pedidos.forEach((pedido) => {
            pesoTotal += pedido.Peso ?? 0;
            volTotal += pedido.QtdeVolumes ?? 0;
          })

          this.distanciasPercorridaMotorAjud[i].pesoTotal = pesoTotal;
          this.distanciasPercorridaMotorAjud[i].volTotal = volTotal;
          this.distanciasPercorridaMotorAjud[i].pedidos = pedidos;

          const agrupado = this.distanciasPercorridaMotorAjud[i].entregas.reduce((acc, item) => {
            if (!acc[item.CodigoCliente]) {
              acc[item.CodigoCliente] = [];
            }
            acc[item.CodigoCliente].push(item);
            return acc;
          }, {});

          const listaAgrupadaEntrega = Object.keys(agrupado).map(codigoCliente => ({
            CodigoCliente: parseInt(codigoCliente),
            Entregas: agrupado[codigoCliente]
          }));

          this.distanciasPercorridaMotorAjud[i].listaAgrupadaEntrega = listaAgrupadaEntrega;

          for (let j = 0; j < listaAgrupadaEntrega.length; j++) {

            const coordenadas = listaAgrupadaEntrega[j].Entregas.map(item => JSON.parse(item.CoordenadaJSON));
            this.inserirLinhaCaminha(coordenadas, corRota);
            distanciaTotal = this.calculaDistanciaPercorrida(coordenadas)
          }

          this.distanciasPercorridaMotorAjud[i].distanciaTotal = distanciaTotal.toFixed(3);

        }
      }
    }
  }

  calculaDistanciaPercorrida(coordenadas: any): number {
    let distanciaTotal = 0
    for (let k = 0; k < coordenadas.length; k++) {
      if (k > 1) {
        let distancia = this.util.calcularDistanciaGeo(
          coordenadas[k - 1].latitude,
          coordenadas[k - 1].longitude,
          coordenadas[k].latitude,
          coordenadas[k].longitude);
        distanciaTotal += distancia;
      }
    }
    return distanciaTotal;
  }

  inserirLinhaCaminha(coordenadas: any, corRota) {
    const path = coordenadas.map(coord => [coord.longitude, coord.latitude]);

    const polyline = new LoadedModules.Polyline({
      paths: [path],
      spatialReference: { wkid: 4326 }
    });

    const polylineGraphic = new LoadedModules.Graphic({
      geometry: polyline,
      symbol: {
        type: "simple-line",
        color: corRota,
        width: 4,
        style: "dot"
      }
    });

    this.graphicService.listaPolylineDistPercorrida.push(polylineGraphic)
    this.graphicService.view.graphics.add(polylineGraphic);
  }


  alteraModoEditoOdometro(preencheCampos = false) {
    if (preencheCampos) {
      this.kmOdometroInicioEdit = this.kmOdometroInicio;
      this.kmOdometroFinalEdit = this.kmOdometroFinal;
    }
    this.modoEdicaoOdometro = !this.modoEdicaoOdometro;
  }

  async salvaOdometro() {
    if (this.kmOdometroInicioEdit == null || this.kmOdometroFinalEdit == null) {
      this.notificationService.showErro("Valores inválidos. Tente novamente.");
      return;
    }
    if (this.kmOdometroInicioEdit > this.kmOdometroFinalEdit) {
      this.notificationService.showErro("Km inicial maior que KM final.");
      return;
    }

    this.modoEdicaoOdometro = false;
    const jsonReturn: JsonReturn = await this.apiConService.patch(`DCroteiros/odometro/atualiza/${this.boxListTruckService.roteiroSelecionado}/${this.kmOdometroInicioEdit}/${this.kmOdometroFinalEdit}`);

    if (jsonReturn.sucesso) {
      this.kmOdometroFinal = this.kmOdometroFinalEdit;
      this.kmOdometroInicio = this.kmOdometroInicioEdit;
      this.distanciaOdometro = (this.kmOdometroFinal - this.kmOdometroInicio)
    } else {
      this.notificationService.showErro('Erro ao atualizar odômetro');
    }
  }

  consultarEditarOdometro() {
    this.carregarFotoOdometro();
    this.showModalOdometro = !this.showModalOdometro;
    this.alteraModoEditoOdometro(true);
    this.modoEdicaoOdometro = true;
  }
}

